import 'src/polyfills/array-prototype-at'

import { loadStripe } from '@stripe/stripe-js'
import mountReactApp, { root } from 'src/utils/mountReactApp'
import parseTipRates from 'src/utils/parseTipRates'
import { installPledge } from 'src/widgets/plugins/pledge'
import InputField from 'src/components/InputField'
import CheckBox from 'src/components/CheckBox'
import StripeWrapper from 'src/widgets/donate_v6/StripeWrapper'
import App from 'src/widgets/donate_v6/App'
import 'src/widgets/donate_v6/backToSearch'
import 'src/widgets/donate_v6/openGiftAidModal'
import 'src/widgets/donate_v6/openModalTriggers'
import 'src/widgets/donate_v6/openShareModal'
import 'src/widgets/donate_v6/standaloneAbandonedCart'

// paypalCurrency defers to paypalProps.currencies; venmo's usdOnly is narrower.
const paymentMethodConfigs = {
  venmo: { oneTimeOnly: true, usdOnly: true },
  bank: { usdOnly: true },
  paypal: { paypalCurrency: true },
}

// Public plugin API (window.Pledge). Plugins register via
// Pledge.widget.addPlugin; the legacy root 'addPlugin' event is bridged into
// the same queue so existing plugins keep working through the migration.
// usePlugins still passes components to hooks via props too, so a v6 plugin
// works whether it reads window.Pledge.components or its incoming props.
const widget = installPledge({ version: 6, components: { InputField, CheckBox } })
root.addEventListener('addPlugin', e => widget.addPlugin(e.detail))

const transformProps = ({
  stripeKey, stripeAccount, tipping, tip_rates, payment_method, payment_methods,
  ...props
}) => {
  const stripePromise = loadStripe(stripeKey, { stripeAccount })

  const paymentMethods = payment_methods.reduce((methods, method) => {
    switch (method) {
    case 'credit_card':
    case 'bank':
    case 'paypal':
    case 'venmo': {
      methods.fiat ||= {}
      methods.fiat[method] = paymentMethodConfigs[method] || {}
      break
    }
    default:
      methods[method] = true
    }
    return methods
  }, {})

  const paymentMethod =
    [ 'credit_card', 'bank', 'paypal', 'venmo' ].includes(payment_method)
    ? 'fiat' : payment_method

  const fiatPaymentMethod = paymentMethod == 'fiat'
  ? payment_method : paymentMethods.fiat
  ? Object.keys(paymentMethods.fiat)[0] : null

  return {
    ...props,
    stripeKey,
    stripePromise,
    // v6 can't run tipping and cover-costs together, so treat 'both' as
    // tipping. v7 honors 'both' as a distinct mode.
    tipping: {
      ...parseTipRates(tip_rates),
      type: tipping == 'both' ? 'tipping' : tipping,
    },
    paymentMethods,
    paymentMethod,
    fiatPaymentMethod,
    // Snapshot of the plugins registered by mount time. transformProps runs on
    // the DCL-deferred MountReactApp dispatch — after the non-async snippet
    // scripts have registered — so the queue is complete here, and v6's
    // usePlugins keys off this array anyway (it never observed in-place queue
    // mutations). A plugin that registers *asynchronously* after mount would
    // miss this snapshot; not a concern today (snippets are synchronous).
    plugins: widget.entries.map(entry => entry.plugin),
    App,
  }
}

mountReactApp(StripeWrapper, transformProps)
